import { Button, Checkbox, DatePicker, Form, FormInstance, Input, Modal, Select, Space } from 'antd';
import React from 'react'
import { TeacherDtoResponse } from '../../../interfaces/Teacher/TeacherDtoResponse';
import { TeacherDtoRequest } from '../../../interfaces/Teacher/TeacherDtoRequest';
import useDictionary from '../../../hooks/useDictionary';
import { TeacherService } from '../../../services/TeacherService';
import { successNotification } from '../../../helpers/successNotification';
import InputMask from "react-input-mask";
import { useTheme } from '../../../themes/useTheme';
import { EditOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import grantPermission from '../../../helpers/grantPermission';
import { HRService } from '../../../services/HRService';
import { DisciplinesService } from '../../../services/DisciplinesService';
import { TeacherPositionDtoResponce } from '../../../interfaces/Teacher/TeacherPositionDtoResponce';
import { TeacherTypeDtoResponse } from '../../../interfaces/Teacher/TeacherTypeDtoResponse';
import { TeacherStatusDtoResponse } from '../../../interfaces/Teacher/TeacherStatusDtoResponse';
import { DepartmentDtoResponse } from '../../../interfaces/DepartmentDtoResponse';
import { TeacherAdditionalInfoDtoRequest } from '../../../interfaces/Teacher/TeacherAdditionalInfoDtoRequest';


interface TeacherEditModalProps {
    form?: FormInstance;
    teacherInfo?: TeacherDtoResponse;
    fetchTeacherData?: () => void;
    id?: number;
}

const TeacherEditModal = ({
    form,
    teacherInfo,
    fetchTeacherData,
    id,
}: TeacherEditModalProps) => {
    const { dictionary } = useDictionary({
        fetchNationailty: true, fetchCitizenship: true, fetchScientificDegree: true,
        fetchKpiType: true, fetchAcademicStatus: true, fetchCountries: true,
    });
    const [open, setOpen] = React.useState(false);
    const [isDarkMode] = useTheme();
    const isHr: boolean | undefined = grantPermission('HR', 'addRole');
    const additionalInfoDtoRequest: TeacherAdditionalInfoDtoRequest[] = [];
    const [isChecked, setIsChecked] = React.useState(false);

    const [positionsList, setPositionsList] = React.useState<TeacherPositionDtoResponce[]>();
    const [teacherTypeList, setTeacherTypeList] = React.useState<TeacherTypeDtoResponse[]>();
    const [teacherStatusList, setTeacherStatusList] = React.useState<TeacherStatusDtoResponse[]>();
    const [deps, setDeps] = React.useState<DepartmentDtoResponse[]>([]);

    React.useEffect(() => {
        TeacherService.getPositionsList()
            .then((res) => setPositionsList(res.data))

        TeacherService.getTypesList()
            .then((res) => setTeacherTypeList(res.data))

        TeacherService.getStatusList()
            .then((res) => setTeacherStatusList(res.data))

        DisciplinesService.getDepartmentsPublic()
            .then((res) => {
                setDeps(res.data);
            })
        teacherInfo?.ftutor && setIsChecked(true);
    }, [teacherInfo?.ftutor]);

    const onUpdate = (teacherData: TeacherDtoRequest) => {
        teacherData.additionalInfo = additionalInfoDtoRequest.filter(value => value);

        isHr
            ?
            id &&
            HRService.updateTeacher(id, teacherData)
                .finally(() => {
                    fetchTeacherData && fetchTeacherData();
                    setOpen(false);
                    successNotification("Profile information updated!")
                })
            :
            TeacherService.updateTeacherInfo(teacherData)
                .finally(() => {
                    fetchTeacherData && fetchTeacherData();
                    setOpen(false);
                    successNotification("Profile information updated!")
                })


    }

    return (
        <>
            <Button
                type="primary"
                icon={<EditOutlined />}
                disabled={teacherInfo?.status.id === 2}
                onClick={() => setOpen(true)}
            >
                Edit
            </Button>
            <Modal
                open={open}
                title="Edit teacher"
                okText="Edit"
                cancelText="Cancel"
                okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
                onCancel={() => setOpen(false)}
                destroyOnClose
                modalRender={(dom) => (
                    <Form
                        layout="vertical"
                        form={form}
                        name="form_in_modal"
                        onFinish={(values) => onUpdate(values)}
                    >
                        {dom}
                    </Form>
                )}
            >
                <Form.Item name={"nameKz"} label={"First name"}>
                    <Input
                        defaultValue={teacherInfo?.nameKz}
                        size={"middle"}
                    />
                </Form.Item>
                <Form.Item name={"surnameKz"} label={"Last name"}>
                    <Input
                        defaultValue={teacherInfo?.surnameKz}
                        size={"middle"}
                    />
                </Form.Item>
                <Form.Item name={"patronymicKz"} label={"Patronymic"}>
                    <Input
                        defaultValue={teacherInfo?.patronymicKz}
                        size={"middle"}
                    />
                </Form.Item>
                <Form.Item name={"nameEn"} label={"First name (English)"}>
                    <Input
                        defaultValue={teacherInfo?.nameEn}
                        size={"middle"}
                    />
                </Form.Item>
                <Form.Item name={"surnameEn"} label={"Last name (English)"}>
                    <Input
                        defaultValue={teacherInfo?.surnameEn}
                        size={"middle"}
                    />
                </Form.Item>
                <Form.Item name={"iin"} label={"IIN"}>
                    <Input
                        defaultValue={teacherInfo?.iin}
                        maxLength={12}
                        size={"middle"}
                    />
                </Form.Item>
                <Form.Item
                    label="Birth Date"
                    name="birthDate"
                    style={{ marginBottom: '10px', width: '100%' }}
                    initialValue={moment(teacherInfo?.birthDate)}
                    getValueFromEvent={(onChange) => moment(onChange).format('YYYY-MM-DD')}
                    getValueProps={(i) => ({ value: i ? moment(i) : null })}
                >
                    <DatePicker placeholder="Select birth date" style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item name={"phone"} label={"Phone"}>
                    <InputMask
                        mask={"+7 (999) 999-99-99"}
                        defaultValue={teacherInfo?.phone}
                        style={isDarkMode ? {
                            backgroundColor: "#1f1f1f",
                            width: "100%",
                            padding: "6.5px 11px 6.5px",
                            border: "1px solid #434343"
                        } : {
                            width: "100%",
                            padding: "6.5px 11px 6.5px",
                            border: "1px solid #434343"
                        }}
                    >
                    </InputMask>
                </Form.Item>
                <Form.Item
                    name={"nationalityId"}
                    label={"Nationality"}
                >
                    <Select placeholder="Select option" defaultValue={teacherInfo?.nationality?.id} size={"middle"} allowClear style={{ width: "100%", borderRadius: "10px" }}>
                        {dictionary.nationalities?.map((option: any) => (
                            <Select.Option key={option.id} value={option.id}>
                                {option.titleEn}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"citizenshipId"}
                    label={"Citizenship"}
                >
                    <Select placeholder="Select option" defaultValue={teacherInfo?.citizenship?.id} size={"middle"} allowClear style={{ width: "100%", borderRadius: "10px" }}>
                        {dictionary.citizenships?.map((option: any) => (
                            <Select.Option key={option.id} value={option.id}>
                                {option.titleEn}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item
                    label="Gender"
                    name="sexId"
                >
                    <Select placeholder="Select option" defaultValue={teacherInfo?.sexId} allowClear size={"middle"} style={{ width: "100%", borderRadius: "10px" }}>
                        {dictionary.genderListEn.map((option) => (
                            <Select.Option key={option.id} value={option.id}>
                                {`${option.value}`}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.List
                    name="scientificInterests"
                    initialValue={teacherInfo?.scientificInterests}
                >
                    {(fields, { add, remove }, { errors }) => (
                        <>
                            {fields.map((field, index) => (
                                <Form.Item
                                    label={index === 0 ? 'Scientific interests' : ''}
                                    required={false}
                                    key={field.key}
                                >
                                    <Form.Item
                                        {...field}
                                        validateTrigger={['onChange', 'onBlur']}
                                        rules={[
                                            {
                                                required: true,
                                                whitespace: true,
                                                message: "Please input scientific interest name or delete this field.",
                                            },
                                        ]}
                                        noStyle
                                    >
                                        <Input placeholder="Scientific interest" style={{ width: "93%" }} />
                                    </Form.Item>
                                    <Button
                                        icon={<MinusCircleOutlined />}
                                        onClick={() => remove(field.name)}
                                    />
                                </Form.Item>
                            ))}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    style={{ width: '100%' }}
                                    icon={<PlusOutlined />}
                                >
                                    Add Scientific Interest
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
                <Form.List
                    name="taughtCourses"
                    initialValue={teacherInfo?.taughtCourses}
                >
                    {(fields, { add, remove }, { errors }) => (
                        <>
                            {fields.map((field, index) => (
                                <Form.Item
                                    label={index === 0 ? 'Taught courses' : ''}
                                    required={false}
                                    key={field.key}
                                >
                                    <Form.Item
                                        {...field}
                                        validateTrigger={['onChange', 'onBlur']}
                                        rules={[
                                            {
                                                required: true,
                                                whitespace: true,
                                                message: "Please input taught course name or delete this field.",
                                            },
                                        ]}
                                        noStyle
                                    >
                                        <Input placeholder="Taught course" style={{ width: "93%" }} />
                                    </Form.Item>
                                    <Button
                                        icon={<MinusCircleOutlined />}
                                        onClick={() => remove(field.name)}
                                    />
                                </Form.Item>
                            ))}
                            <Form.Item>
                                <Button
                                    type="dashed"
                                    onClick={() => add()}
                                    style={{ width: '100%' }}
                                    icon={<PlusOutlined />}
                                >
                                    Add Taught Course
                                </Button>
                            </Form.Item>
                        </>
                    )}
                </Form.List>
                <Form.Item
                    label="Employment type"
                    name="typeId"
                    style={{ marginBottom: '10px' }}
                >
                    <Select placeholder="Select employment type" defaultValue={teacherInfo?.type.id} allowClear>
                        {teacherTypeList?.map((option) => (
                            <Select.Option key={option.id} value={option.id}>
                                {`${option.name}`}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Position"
                    name="positionId"
                    style={{ marginBottom: '10px' }}
                >
                    <Select placeholder="Select position" defaultValue={teacherInfo?.position.id} allowClear>
                        {positionsList?.map((option) => (
                            <Select.Option key={option.id} value={option.id}>
                                {`${option.name}`}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                {/* <Form.Item
                    label="KPI позиция"
                    name="kpiPosition"
                    style={{ marginBottom: '10px' }}
                >
                    <Select placeholder="Выберите должность" allowClear>
                        {dictionary.positions?.map((option) => (
                            <Select.Option key={option} value={option}>
                                {`${option}`}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item> */}

                <Form.Item
                    label="Scientific degree"
                    name="scientificDegreeId"
                    style={{ marginBottom: '10px' }}
                >
                    <Select placeholder="Select scientific degree" defaultValue={teacherInfo?.scientificDegree?.id} allowClear>
                        {dictionary.scientificDegrees?.map((option) => (
                            <Select.Option key={option.id} value={option.id}>
                                {`${option.nameRu}/${option.nameKz}/${option.nameEn}`}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Academic status"
                    name="academicStatusId"
                    style={{ marginBottom: '10px' }}
                >
                    <Select placeholder="Select acamdemic status" defaultValue={teacherInfo?.academicStatus?.id} allowClear>
                        {dictionary.academicStatuses?.map((option) => (
                            <Select.Option key={option.id} value={option.id}>
                                {`${option.nameRu}/${option.nameKz}/${option.nameEn}`}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Status"
                    name="statusId"
                    style={{ marginBottom: '10px' }}
                >
                    <Select placeholder="Select status" defaultValue={teacherInfo?.status?.id} allowClear>
                        {teacherStatusList?.map((option) => (
                            <Select.Option key={option.id} value={option.id}>
                                {`${option.name}`}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Department"
                    name="departmentId"
                    style={{ marginBottom: '10px' }}
                >
                    <Select placeholder="Select department" defaultValue={teacherInfo?.department?.id} allowClear>
                        {deps?.map((option) => (
                            <Select.Option key={option.id} value={option.id}>
                                {`${option.titleKz}/${option.titleRu}/${option.titleEn}`}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>

                <Form.Item
                    label="Foreign teacher"
                    valuePropName="checked"
                    name="ftutor"
                    initialValue={false}
                    style={{ marginBottom: '10px' }}
                >
                    <Checkbox onChange={e => setIsChecked(e.target.checked)} />
                </Form.Item>

                {(isChecked || teacherInfo?.additionalInfoDto) && (
                    <>
                        <Form.Item label="Name of the foreign scientist's organization" style={{ marginBottom: '10px' }}>
                            <Input
                                defaultValue={teacherInfo?.additionalInfoDto?.find((value) => value.type.name === "F_UNIVERSITY")?.value}
                                placeholder="Enter the name of the foreign scientist's organization"
                                onChange={e => additionalInfoDtoRequest[0] = { type: "F_UNIVERSITY", value: e.target.value }}
                            />
                        </Form.Item>

                        <Form.Item label="Country of the foreign scientist's university" style={{ marginBottom: '10px' }}>
                            <Select
                                placeholder="Select the country of the university"
                                defaultValue={teacherInfo?.additionalInfoDto?.find((value) => value.type.name === "F_UNIVERSITY_COUNTRY")?.value}
                                onSelect={(e) => additionalInfoDtoRequest[1] = { type: "F_UNIVERSITY_COUNTRY", value: e }}
                            >
                                {dictionary.countries?.map((data) => (
                                    <Select.Option key={data.id} value={data.id}>
                                        {`${data.nameEn}`}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item label="Specialty" style={{ marginBottom: '10px' }}>
                            <Input
                                placeholder="Enter the specialty"
                                defaultValue={teacherInfo?.additionalInfoDto?.find((value) => value.type.name === "SPECIALITY")?.value}
                                onChange={e => additionalInfoDtoRequest[2] = { type: "SPECIALITY", value: e.target.value }}
                            />
                        </Form.Item>

                        <Space style={{ marginBottom: '10px' }}>
                            <Form.Item label="Start date of stay">
                                <DatePicker
                                    format="YYYY-MM-DD"
                                    defaultValue={moment(teacherInfo?.additionalInfoDto?.find((value) => value.type.name === "F_START_DATE")?.value)}
                                    placeholder="Select date"
                                    onChange={(value, dateString) => additionalInfoDtoRequest[3] = { type: "F_START_DATE", value: dateString }}
                                />
                            </Form.Item>
                            <Form.Item label="End date of stay">
                                <DatePicker
                                    format="YYYY-MM-DD"
                                    defaultValue={moment(teacherInfo?.additionalInfoDto?.find((value) => value.type.name === "F_END_DATE")?.value)}
                                    placeholder="Select date"
                                    onChange={(value, dateString) => additionalInfoDtoRequest[4] = { type: "F_END_DATE", value: dateString }}
                                />
                            </Form.Item>
                        </Space>
                    </>
                )}

                <Form.Item
                    label="Married"
                    valuePropName="checked"
                    name="isMarried"
                    initialValue={teacherInfo?.isMarried}
                >
                    <Checkbox />
                </Form.Item>
                <Form.Item
                    label="On maternity leave"
                    valuePropName="checked"
                    name="maternityLeave"
                    initialValue={teacherInfo?.maternityLeave}
                >
                    <Checkbox />
                </Form.Item>
                <Form.Item
                    label="Resident of Kazakhstan"
                    valuePropName="checked"
                    name="isResident"
                    initialValue={teacherInfo?.isResident}
                >
                    <Checkbox />
                </Form.Item>
            </Modal >
        </>
    )
}

export default TeacherEditModal